import { create } from '@ebay/nice-modal-react';

import AutoRemindersStepModal from './AutoRemindersStepModal/AutoRemindersStepModal';
import useCreateNewRoomDataContext from './CreateNewRoomDataProvider/useCreateNewRoomDataContext';
import withCreateNewRoomDataProvider from './CreateNewRoomDataProvider/withCreateNewRoomDataProvider';
import CreateRoomStepModal from './CreateRoomStepModal/CreateRoomStepModal';
import DiscardConfirmationModal from './DiscardConfirmationModal';
import InviteParticipantsStepModal from './InviteParticipantsStepModal/InviteParticipantsStepModal';
import ReviewRoomStepModal from './ReviewRoomStepModal/ReviewRoomStepModal';
import { CreateNewRoomStepsEnum } from './utils';

interface CreateNewRoomModalProps {
  onGoBack?: () => void;
  hideScheduling?: boolean;
}

const CreateNewRoomModal = create(
  withCreateNewRoomDataProvider(({ onGoBack, hideScheduling }: CreateNewRoomModalProps) => {
    const { currentStep } = useCreateNewRoomDataContext();

    if (currentStep === CreateNewRoomStepsEnum.CREATE_ROOM) {
      return <CreateRoomStepModal onGoBack={onGoBack} hideScheduling={hideScheduling} />;
    }
    if (currentStep === CreateNewRoomStepsEnum.INVITE_PARTICIPANTS) return <InviteParticipantsStepModal />;
    if (currentStep === CreateNewRoomStepsEnum.SET_AUTO_REMINDERS) return <AutoRemindersStepModal />;
    if (currentStep === CreateNewRoomStepsEnum.REVIEW_ROOM) return <ReviewRoomStepModal />;
    if (currentStep === CreateNewRoomStepsEnum.DISCARD) return <DiscardConfirmationModal />;

    throw new Error(`Reached unknown currentStep value: ${currentStep}`);
  })
);

export default CreateNewRoomModal;
